 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		226: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"1a4fc3c","1":"b36874f","2":"e135534","3":"304c036","4":"52cadf5","5":"6e9aa7d","6":"4e5b537","7":"eea1076","8":"600c36e","9":"f2eb43d","10":"b17279e","11":"6b5f67a","12":"62042e1","13":"283af99","14":"5eeecac","15":"56baee4","16":"1540744","17":"4816d68","18":"b82de72","19":"2114548","20":"100cc7a","21":"6b3098f","22":"6adc24b","23":"34f80e0","24":"d383818","25":"b8e31d0","26":"feb5773","27":"44ae226","28":"f05ae9e","29":"cee50ec","30":"dbbbf8e","31":"43ea3a1","32":"43df235","33":"8f57722","34":"b5babc9","35":"5c2f481","36":"e970992","37":"853f108","38":"2e18852","39":"efbf899","40":"73b4897","41":"86a0cc6","42":"6c8a89b","43":"ce145bc","44":"27e9acf","45":"877fde3","46":"a9042d8","47":"4226db2","48":"0b146d2","49":"3e3828f","50":"3badd22","51":"7b687f2","52":"1a48b65","53":"8888168","54":"07dd2bb","55":"10f1fc6","56":"74a091b","57":"10b06e0","58":"e7eda3c","59":"82b13f1","60":"ae532fa","61":"f06a354","62":"a391567","63":"a01407e","64":"896d398","65":"1e0e39c","66":"b5d59b1","67":"ccf028a","68":"7a16138","69":"a72425b","70":"5537f54","71":"7d08de3","72":"8acdd07","73":"b66e0f0","74":"3fe0e48","75":"cab7a24","76":"82e8ba9","77":"9addf23","78":"f5f6e84","79":"951d7f1","80":"a60744c","81":"503b370","82":"167ba61","83":"1451b5c","84":"e2e3e11","85":"a7dbcdf","86":"c64fa2a","87":"687f4e7","88":"336e424","89":"03ff8cb","90":"ab67996","91":"55c40d4","92":"1615ede","93":"e0354f2","94":"1d5d9d3","95":"c6845d6","96":"504b005","97":"274c198","98":"7c94e81","99":"196e854","100":"10a198b","101":"1d4d438","102":"fac7cfe","103":"8707e49","104":"dcd99a3","105":"b429ccb","106":"19e5239","107":"5995c76","108":"ac3fa18","109":"e98045e","110":"b9d41eb","111":"c49d3c1","112":"2e99786","115":"53808a8","116":"d14b343","117":"eae8aff","118":"411d902","119":"133a9f1","120":"c678029","121":"65c95c5","122":"d0b9822","123":"5964b0a","124":"7acb8d5","125":"a106b85","126":"f8485ba","127":"03fa0fb","128":"6161f40","129":"c689609","130":"15fd7c0","131":"e0d714e","132":"26c1c8f","133":"68c70d8","134":"7023fd9","135":"cc5633b","136":"b7de0fd","137":"feee4c6","138":"47b163a","139":"110efec","140":"ac56efa","141":"e88d84f","142":"de0cf6b","143":"e7d5708","144":"76e9cb2","145":"03e2c85","146":"c2a7032","147":"c27c948","148":"369edcd","149":"94d1d59","150":"2bb0cf9","151":"db7fa72","152":"836726a","153":"d72fa9b","154":"2b8979b","155":"759f77e","156":"d520dac","157":"c8d34fa","158":"92ff1c3","159":"7e34f3a","160":"8fd08a3","161":"9a92d36","162":"ad81bda","163":"1f53dd5","164":"2cff357","165":"00110c1","166":"b9f1b11","167":"524c149","168":"1508283","169":"0593547","170":"262293a","171":"cd324aa","172":"5b87633","173":"92d9f03","174":"5681618","175":"c477541","176":"818ef70","177":"127f2ad","178":"1aa3ed5","179":"c523982","180":"cf1b0d7","181":"f026a8c","182":"8cd09d2","183":"a164f58","184":"5f198fc","185":"77db6fa","186":"6a18ca5","187":"d37112b","188":"e671654","189":"5df7ab8","190":"a88cc80","191":"334384a","192":"412c142","193":"2fb79e4","194":"3223b17","195":"e8d9e91","196":"faea12e","197":"f204c48","198":"76dc92f","199":"a58b363","200":"7ec36f7","201":"cbb65be","202":"609c00c","203":"82a6600","204":"f86828a","205":"06cd5e1","206":"5bfd766","207":"090dabd","208":"dc2ee32","209":"589a3b9","210":"6a16769","211":"ffab9aa","212":"6b9ac7c","213":"233cb8d","214":"38788de","215":"2a5d030","216":"23ac509","217":"f0076c9","218":"b11b69a","219":"865dc36","220":"398bc42","221":"53fc90c","222":"0542083","223":"8be12d6","224":"6de8416","225":"2f15d6e","228":"d418b49","229":"2e94880","230":"b9d782f","231":"1b1bc20","232":"4ddc435","233":"0fedbaf","234":"dc1bcab","235":"9d33fe6","236":"e65398b","237":"fc08ae5","238":"0ec4310","239":"ae6c54d","240":"c9129e8","241":"b99c1bc","242":"4329c91","243":"e4dd0b8","244":"ab4aaee","245":"224702e","246":"75b9eb7","247":"d5d64e0","248":"afcc3a0","249":"c6fc49f","250":"1b7b846","251":"9009073","252":"762c9f8","253":"8ea9b00","254":"4a44141","255":"83296e6","256":"c5d6b69","257":"f85cb5f","258":"42d8721","259":"05abed2","260":"10f19bd","261":"0703cb2","262":"f36d285","263":"3706ab1","264":"fce942e","265":"6871ac1","266":"ece6100","267":"cd8830b","268":"cc2b4e8","269":"5cb2d3a","270":"6c676d5","271":"c91934e","272":"8d4bebc","273":"6b8d9f3","274":"61656ac","275":"fb84948","276":"44b2522","277":"13bb062","278":"153b115","279":"9fec819","280":"247a563","281":"a7863be","282":"4419360","283":"eeb55c4","284":"e7f4a20","285":"58c0f46","286":"32a636c","287":"c8fc85b","288":"55016e3","289":"035a7fe","290":"7769df9","291":"9cb657d","292":"3793150","293":"f975c1b","294":"288038e","295":"e5051e8","296":"c51ccde","297":"e8355df","298":"c6e43d1","299":"c41ada5","300":"5e12cd7","301":"6cc010a","302":"1a0f83a","303":"245ea9f","304":"0de806a","305":"22653fb","306":"0272f67","307":"66be3cd","308":"0ca480e","309":"0ce2276","310":"a040343","311":"9a193d7","312":"b9d1e4f","313":"82b72a1","314":"a943bbe","315":"0d32275","316":"906bbe7","317":"6e595b0","318":"9a3aef4","319":"761796a","320":"6b6213b","321":"787ec66","322":"59b4278","323":"c18bfa8","324":"4978cb3","325":"60840e8","326":"f4dd148","327":"e727d99","328":"9b280ce","329":"9586fff","330":"28f7c89","331":"7c91dd9","332":"b2a4c83","333":"68097cf","334":"3c30633","335":"0f43aa2","336":"b6d416e","337":"96009cc","338":"17a04d3","339":"659967e","340":"f2d3774"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
